// src/components/PostMenu.jsx
"use client";

import { Trash } from "lucide-react";
import ObjectActionMenu from "@/components/ui/ObjectActionMenu";

/**
 * Small, self-contained menu for posts.
 * - Click to toggle
 * - Click outside closes
 * - Emits onDelete() when "Delete" is clicked
 * - Uses icon-only halo on the trigger
 */
export default function PostMenu({ onDelete }) {
  return (
    <ObjectActionMenu
      label="Post menu"
      items={[
        {
          label: "Delete",
          icon: Trash,
          tone: "danger",
          onSelect: onDelete,
        },
      ]}
    />
  );
}
